// src/context/DashboardContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [user, setUser] = useState({ name: "Gamze" });
  const [stats, setStats] = useState({
    totalServices: 10,
    totalEmployees: 50,
    totalCustomers: 100,
    dailyCash: { online: 0, offline: 0, other: 0, net: 0 },
    recentServices: [],
    districtData: [],
    topStocks: []
  });


  return (
    <DashboardContext.Provider value={{ user, stats }}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);
